module.exports = __webpack_public_path__ + "static/media/marketing.2eed95a2.jpg";